import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { uploadImage } from "../../redux/actions/createcampaign";
import { Add } from "@mui/icons-material";
import { Button, Grid, MenuItem, TextField, Toolbar, Tooltip } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  createFooter,
  getForFooter,
} from "../../redux/actions/addCampaigndata.js";
import { Col, Row } from "react-bootstrap";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StarRateIcon from '@mui/icons-material/StarRate';
import DeleteIcon from "@mui/icons-material/Delete";
import InputFieldOrder from "./comman/InputFieldOrder.jsx";
import { motion } from "framer-motion";


const logoSchema = yup.array().of(
  yup.object().shape({
    file: yup
      .mixed()
      .required("Image is required")
      .test("fileFormat", "Unsupported file format", (value) => {
        if (!value || !value.file) {
          return true;
        }
        const file = value.file;
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
        return supportedFormats.includes(fileExtension);
      }),
    link: yup.string().url("Invalid URL format"),
    target: yup.string(),
    order: yup.number().notRequired(),
    alt: yup.string().required(""),
  })
);
const common = yup.array().of(
  yup.object().shape({
    link: yup.string().url("Invalid URL format"),
    target: yup.string(),
    order: yup.number().notRequired(),
    text: yup.string().required("Text is required"),
  })
);
const commons = yup.array().of(
  yup.object().shape({
    link: yup.string().url("Invalid URL format"),
    target: yup.string(),
    order: yup.number().notRequired(),
    text: yup.string(),
  })
).notRequired();


const customerSupports = yup.array().of(
  yup.object().shape({
    text: yup.string().required(""),
    value: yup.string().required(""),
    order: yup.number().required(""),
    link: yup
      .string()
      .test('is-valid-link', 'Invalid link format', (value) => {
        if (!value) return true; // Allow empty link
        return value.startsWith("mailto:") || isValidURL(value);
      })
      .required("Link is required"),
  })
);

function isValidURL(url) {
  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
}

const footerImage = yup.object().shape({
  file: yup
    .mixed()
    .required("Image is required")
    .test("fileFormat", "Unsupported file format", (value) => {
      if (!value || !value.file) {
        return true;
      }
      const file = value.file;
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
      return supportedFormats.includes(fileExtension);
    }),
  logo: yup.string().required(""),
  link: yup.string().url("Invalid URL format").required(""),
});

const schema = yup.object().shape({
  footer_logo: footerImage,
  social_media: logoSchema,
  customer_support: customerSupports,
  brand_partners: commons,
  quick_links: common,
  bank_partners: commons,
  footer_images: logoSchema,
  copy_right: yup.string().required("copy_right is required"),
});

const FooterCreation = (props) => {
  const { handleNext, activeStep, handleBack } = props;

  const selector = useSelector((state) => state.addCampaignReducer);
  const campaignId = localStorage.getItem("campaignId") ?? selector.campaignId;
  const uiType = localStorage.getItem("uiType") || selector?.perticular?.uiType;



  // collapse state
  const [columnVisibility, setColumnVisibility] = useState({
    footer_logo: false,
    customer_support: false,
    brand_partners: false,
    social_media: false,
    quick_links: false,
    bank_partners: false,
    footer_images: false,
  });

  const toggleColumn = (columnName) => {
    setColumnVisibility({
      ...columnVisibility,
      [columnName]: !columnVisibility[columnName],
    });
  };

  //button
  const [buttonClicked, setButtonClicked] = useState(false);


  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    formState: { errors },
    register,
    clearErrors,
    setError,
    setValue,
    watch,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),

    defaultValues: {
      footer_logo: { file: null, link: "" },
      social_media: [
        { file: null, target: "_self", link: "", alt: "", order: null },
      ],
      customer_support: [{ text: "", value: "", order: null, link: "" }],
      brand_partners: [{ text: "", link: "", order: null, target: "_self" }],
      bank_partners: [{ text: "", link: "", order: null, target: "_self" }],
      quick_links: [{ text: "", link: "", order: null, target: "_self" }],
      footer_images: [
        { file: null, target: "_self", link: "", alt: "", order: null },
      ],
      uiType: "",
      campaignId: "",
      copy_right: "",
      // disclaimer: "",
    },
  });

  const {
    fields: photoFields,
    append: appendPhoto,
    remove: removePhoto,
  } = useFieldArray({
    control,
    name: "footer_images",
  });
  const {
    fields: brandPartners,
    append: appendbrandPartners,
    remove: removebrandPartners,
  } = useFieldArray({
    control,
    name: "brand_partners",
  });

  const {
    fields: bankPartners,
    append: appendbankPartners,
    remove: removebankPartners,
  } = useFieldArray({
    control,
    name: "bank_partners",
  });

  const {
    fields: customerSupport,
    append: appendcustomerSupport,
    remove: removecustomerSupport,
  } = useFieldArray({
    control,
    name: "customer_support",
  });
  const {
    fields: quickLinks,
    append: appendquickLinks,
    remove: removequickLinks,
  } = useFieldArray({
    control,
    name: "quick_links",
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "social_media",
  });


  const handleImage = async (index, logo, e) => {
    const file = e.target.files[0];

    const isImage = file && file.type.startsWith("image/");

    const formData = new FormData();
    formData.append("image", file);

    if (logo === "footer_logo") {
      clearErrors(`footer_logo.file`);
      if (!isImage) {
        setError(`footer_logo.file`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`footer_logo.logo`, res);
          setValue(`footer_logo.file`, res);
          // setImageLinks((prevImageLinks) => ({
          //   ...prevImageLinks,
          //   [logo]: res,
          // }));
        });
      }
    } else if (logo === "social_media") {
      clearErrors(`social_media[${index}].file`);
      if (!isImage) {
        setError(`social_media[${index}].file`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`social_media[${index}].logo`, res);
          setValue(`social_media[${index}].file`, res);
        });
      }
    } else {
      clearErrors(`footer_images[${index}].file`);
      if (!isImage) {
        setError(`footer_images[${index}].file`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`footer_images[${index}].image`, res);
          setValue(`footer_images[${index}].file`, res);

        });
      }
    }
  };


  const user = localStorage.getItem("userID");

  const onSubmit = async (data) => {

    const { file: footer_logo, ...footer } = data.footer_logo;
    data.footer_logo = footer;

    const recreatedSocialArray = data.social_media.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });
    const recreatedFooterArray = data.footer_images.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });


    const { brand_partners, bank_partners, ...newData } = data;
    const checkBrand = !brand_partners && !brand_partners?.[0] ? false : true;
    const checkBank = !bank_partners && !bank_partners?.[0] ? false : true;


    const recreatedData = {
      ...newData,
      ...(checkBrand ? { brand_partners: brand_partners } : {}),
      ...(checkBank ? { bank_partners: bank_partners } : {}),
      social_media: recreatedSocialArray,
      footer_images: recreatedFooterArray,
      created_by: user,
      campaignId: data?.campaignId || localStorage.getItem("updateID")
    };

    const result = await dispatch(createFooter(recreatedData));

    if (result?.success === true) {
      handleNext();
    }
  };

  useEffect(() => {
    if (uiType !== null && uiType !== undefined) {
      setValue("uiType", uiType);
    }
    if (campaignId !== null && campaignId !== undefined) {
      setValue("campaignId", campaignId);
    }
    dispatch(getForFooter());
  }, [uiType, campaignId]);

  const { footerData } = useSelector((state) => state.addCampaignReducer);

  const setFooter = footerData?.map((data) => {
    return data;
  });

  const handleGetData = async () => {
    try {
      if (uiType == "external") {
        const res = setFooter[0];
        setValue("footer_logo", res?.footer_logo);
        setValue("footer_logo.file", res?.footer_logo.logo);

        setValue("customer_support", res?.customer_support);
        setValue("social_media", res?.social_media);
        res?.social_media?.map((socialMedia, index) => {
          setValue(`social_media[${index}].file`, socialMedia?.logo);

        });
        setValue("footer_images", res?.footer_images);
        res?.footer_images?.map((footerImage, index) => {
          setValue(`footer_images[${index}].file`, footerImage?.image);
          // setImageLinks((prevState) => ({
          //   ...prevState,
          //   [`footer_images`]: [...(prevState[`footer_images`] || []), footerImage?.image],
          // }));
        });

        setValue("brand_partners", res?.brand_partners);
        setValue("bank_partners", res?.bank_partners);
        setValue("quick_links", res?.quick_links);
        setValue("copy_right", res?.copy_right);
        clearErrors(`footer_logo.file`)
      } else {
        const res = setFooter[1];
        setValue("footer_logo", res?.footer_logo);
        setValue("footer_logo.file", res?.footer_logo.logo);
        setValue("customer_support", res?.customer_support);
        setValue("social_media", res?.social_media);
        res?.social_media?.map((socialMedia, index) => {
          setValue(`social_media[${index}].file`, socialMedia?.logo);

        });
        setValue("footer_images", res?.footer_images);
        res?.footer_images?.map((footerImage, index) => {
          setValue(`footer_images[${index}].file`, footerImage?.image);

        });
        setValue("brand_partners", res?.brand_partners);
        setValue("bank_partners", res?.bank_partners);
        setValue("quick_links", res?.quick_links);
        setValue("copy_right", res?.copy_right);
        clearErrors(`footer_logo.file`)
      }
      setButtonClicked(true);
    } catch (error) {
      setButtonClicked(false);
    }
  };

  const handleUrlChange = (index, logo, e) => {
    const urlValue = e.target.value.trim();
    if (logo === "footer_logo" || logo === "social_media") {
      clearErrors(`${logo}[${index}].file`);
      setValue(`${logo}[${index}].image`, urlValue);
      setValue(`${logo}[${index}].file`, urlValue);
    } else if (logo === "footer_images") {
      clearErrors(`${logo}[${index}].file`);
      setValue(`${logo}[${index}].logo`, urlValue);
      setValue(`${logo}[${index}].file`, urlValue);
    }
  };

  console.log(errors, "errors")


  return (
    <div className="">
      <Row>
        <Col lg={12}>
          <Button onClick={handleGetData} variant="contained" disabled={buttonClicked}>
            Previous footer Data
          </Button>
        </Col>
      </Row>
      <form onSubmit={handleSubmit(onSubmit)}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="text-center fw-bold mb-3 border-bottom border-2 border-info pb-1"
          style={{ fontSize: "20px", color: "rgba(0, 165, 162, 0.9)" }}
        >
          Footer Section
        </motion.div>
        <div className="container">
          <Row>
            <Col lg={6} >
              <div className={`text-success fw-bold text-center buttons rounded-2 ${errors.footer_logo && "error"}`} style={{ cursor: "pointer" }} onClick={() => toggleColumn('footer_logo')}>
                Footer Logo <StarRateIcon className={`${errors.footer_logo && "text-danger"}`} />  {columnVisibility.footer_logo ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
              </div>
              <div className="column" style={{ display: columnVisibility.footer_logo ? 'block' : 'none' }}>
                <div className="d-flex justify-content-around mb-3 mt-2">
                  <Button
                    variant="contained"
                    component="label"
                    {...register(`footer_logo.file`)}
                    onClick={() => clearErrors(`footer_logo.file`)} // Clear errors for URL when file input is clicked
                  >
                    Upload File
                    <input
                      type="file"
                      {...register(`footer_logo.file`)}
                      hidden
                      onChange={(e) => handleImage(0, "footer_logo", e)}
                      className={`file_button mb-1 ${errors.footer_logo && errors?.footer_logo?.file ? "error" : ""}`}
                    />
                  </Button>
                  {watch(`footer_logo`).logo && (
                    <div className="image_div">
                      <img
                        src={watch(`footer_logo`).logo}
                        alt=""
                        width={100}
                        height="auto"
                        className="rounded image"
                      />
                    </div>
                  )}

                </div>
                <Controller
                  name={`footer_logo.file`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Footer Logo Image Url"
                      className={`w-100 mb-3 ${errors.footer_logo && errors?.footer_logo.file
                        ? "error"
                        : ""
                        }`}
                      value={field.value || ""}
                      onChange={(e) => handleUrlChange(0, "footer_logo", e)}
                    />
                  )}
                />
                <Controller
                  name={`footer_logo.link`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      // required
                      {...field}
                      label="Footer Logo Link"
                      className={`w-100 ${errors.footer_logo && errors?.footer_logo.link
                        ? "error"
                        : ""
                        }`}
                    />
                  )}
                />
              </div>
              <hr className="" />
            </Col>
            <Col lg={6} className="">
              <div className={`text-success fw-bold text-center buttons rounded-2 ${errors.customer_support && "error"}`} style={{ cursor: "pointer" }} onClick={() => toggleColumn('customer_support')}>
                Create Customer Support <StarRateIcon className={`${errors.customer_support && "text-danger"}`} /> {columnVisibility.customer_support ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
              </div>
              <div style={{ display: columnVisibility.customer_support ? 'block' : 'none' }}>
                {customerSupport.map((item, index) => (
                  <div key={item.id} className="form-row ">
                    <div className="column d-flex gap-3">
                      <Controller
                        name={`customer_support[${index}].text`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Text"
                            className={`form-control mb-3 ${errors.customer_support &&
                              errors?.customer_support[index]?.text
                              ? "error"
                              : ""
                              }`}
                          />
                        )}
                      />
                      <Controller
                        name={`customer_support[${index}].order`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Order"
                            select
                            className={`form-control mb-3 ${errors.customer_support &&
                              errors?.customer_support[index]?.order
                              ? "error"
                              : ""
                              }`}
                          >
                            {[...Array(15).keys()].map((number) => (
                              <MenuItem
                                key={number + 1}
                                value={(number + 1).toString()}
                              >
                                {number + 1}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                      />
                    </div>
                    <div className="column">
                      <Controller
                        name={`customer_support[${index}].value`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Value"
                            className={`form-control mb-3 ${errors.customer_support &&
                              errors?.customer_support[index]?.value
                              ? "error"
                              : ""
                              }`}
                          />
                        )}
                      />
                    </div>

                    <div className="column">
                      <Controller
                        name={`customer_support[${index}].link`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Link"
                            className={`form-control mb-3 ${errors.customer_support &&
                              errors?.customer_support[index]?.link
                              ? "error"
                              : ""
                              }`}
                          />
                        )}
                      />
                    </div>
                    <div className="column d-flex justify-content-end">
                      {customerSupport.length > 0 &&
                        <Tooltip title="Delete" arrow>
                          <DeleteIcon onClick={() => removecustomerSupport(index)} style={{ color: "red", cursor: "pointer" }} />
                        </Tooltip>
                      }
                    </div>
                  </div>
                ))}
                <div className="form-row  mb-2">
                  <Grid className="d-flex justify-content-between">
                    <Tooltip title="Add" arrow>
                      <Button
                        className="button "
                        variant="outlined"
                        disableElevation
                        startIcon={<Add />}
                        onClick={() =>
                          appendcustomerSupport({
                            text: "",
                            value: "",
                            order: "",
                          })
                        }
                      >
                        Add
                      </Button>
                    </Tooltip>

                  </Grid>
                </div>
              </div>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <div className={`text-success fw-bold text-center buttons rounded-2 ${errors.main_banner_desktop && "error"}`} style={{ cursor: "pointer" }} onClick={() => toggleColumn('brand_partners')}>
                Create  Brand Partners  {columnVisibility.brand_partners ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
              </div>
              <div style={{ display: columnVisibility.brand_partners ? 'block' : 'none' }}>
                {brandPartners.map((item, index) => (
                  <div key={item.id} className="form-row ">
                    <div className="column">
                      <Controller
                        name={`brand_partners[${index}].text`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Text"
                            className={`form-control mb-2 ${errors.brand_partners &&
                              errors?.brand_partners[index]?.text
                              ? "error"
                              : ""
                              }`}
                          />
                        )}
                      />
                    </div>

                    <div className="column">
                      <Controller
                        name={`brand_partners[${index}].link`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Link"
                            className={`form-control mb-2 ${errors.brand_partners &&
                              errors?.brand_partners[index]?.link
                              ? "error"
                              : ""
                              }`}
                          />
                        )}
                      />
                    </div>
                    <div className="column d-flex gap-3">
                      <Controller
                        name={`brand_partners[${index}].target`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Target"
                            select
                            className={`form-control mb-2 ${errors.brand_partners &&
                              errors?.brand_partners[index]?.target
                              ? "error"
                              : ""
                              }`}
                          >
                            <MenuItem value="_self">_self</MenuItem>
                            <MenuItem value="_blank">_blank</MenuItem>
                          </TextField>
                        )}
                      />
                      <Controller
                        name={`brand_partners[${index}].order`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Order"
                            select
                            className={`form-control mb-2 ${errors.brand_partners &&
                              errors?.brand_partners[index]?.order
                              ? "error"
                              : ""
                              }`}
                          >
                            {[...Array(15).keys()].map((number) => (
                              <MenuItem
                                key={number + 1}
                                value={(number + 1).toString()}
                              >
                                {number + 1}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                      />
                    </div>
                    <div className="column d-flex justify-content-end">
                      {brandPartners.length > 0 &&
                        <Tooltip title="Delete" arrow>
                          <DeleteIcon onClick={() => removebrandPartners(index)} style={{ color: "red", cursor: "pointer" }} />
                        </Tooltip>
                      }
                    </div>
                  </div>
                ))}
                <div className="form-row  mb-2">
                  <Grid className="d-flex justify-content-between">
                    <Tooltip title="Delete" arrow>
                      <Button
                        className="button "
                        variant="outlined"
                        disableElevation
                        startIcon={<Add />}
                        onClick={() =>
                          appendbrandPartners({
                            link: "",
                            target: "",
                            order: "",
                            text: "",
                          })
                        }
                      >
                        ADD
                      </Button>
                    </Tooltip>
                  </Grid>
                </div>
              </div>
              <hr />
            </Col>
            <Col lg={6}>
              <div className={`text-success fw-bold text-center buttons rounded-2 ${errors.social_media && "error"}`} style={{ cursor: "pointer" }} onClick={() => toggleColumn('social_media')}>
                Create Social Media <StarRateIcon className={`${errors.social_media && "text-danger"}`} />  {columnVisibility.social_media ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
              </div>
              <div style={{ display: columnVisibility.social_media ? 'block' : 'none' }}>
                <InputFieldOrder
                  fieldName={`social_media`}
                  appendfunc={append}
                  remove={remove}
                  fieldsArray={fields}

                  watch={watch}
                  register={register}
                  handleImageFunc={handleImage}
                  clearErrorsfunc={clearErrors}
                  handleUrlChangefunc={handleUrlChange}
                  control={control}
                  errors={errors}
                />
              </div>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col lg={6} className="mt-3">
              <div className={`text-success fw-bold text-center buttons rounded-2 mb-3 ${errors.quick_links && "error"}`} style={{ cursor: "pointer" }} onClick={() => toggleColumn('quick_links')}>
                Create Quick Links <StarRateIcon className={`${errors.quick_links && "text-danger"}`} />  {columnVisibility.quick_links ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
              </div>
              <div style={{ display: columnVisibility.quick_links ? 'block' : 'none' }}>
                {quickLinks.map((item, index) => (
                  <div key={item.id} className="form-row ">
                    <div className="column">
                      <Controller
                        name={`quick_links[${index}].text`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Text"
                            className={`form-control mb-2 ${errors.quick_links &&
                              errors?.quick_links[index]?.text
                              ? "error"
                              : ""
                              }`}
                          />
                        )}
                      />
                    </div>

                    <div className="column">
                      <Controller
                        name={`quick_links[${index}].link`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Link"
                            className={`form-control mb-2 ${errors.quick_links &&
                              errors?.quick_links[index]?.link
                              ? "error"
                              : ""
                              }`}
                          />
                        )}
                      />
                    </div>
                    <div className="d-flex gap-3">
                      <Controller
                        name={`quick_links[${index}].target`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Target"
                            select
                            className={`form-control mb-2 ${errors.quick_links &&
                              errors?.quick_links[index]?.target
                              ? "error"
                              : ""
                              }`}
                          >
                            <MenuItem value="_self">_self</MenuItem>
                            <MenuItem value="_blank">_blank</MenuItem>
                          </TextField>
                        )}
                      />
                      <Controller
                        name={`quick_links[${index}].order`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            select
                            label="Enter Order"
                            className={`form-control mb-2 ${errors.quick_links &&
                              errors?.quick_links[index]?.order
                              ? "error"
                              : ""
                              }`}
                          >
                            {[...Array(15).keys()].map((number) => (
                              <MenuItem
                                key={number + 1}
                                value={(number + 1).toString()}
                              >
                                {number + 1}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                      />
                    </div>
                    <div className="column d-flex justify-content-end">
                      {quickLinks.length > 0 &&
                        <Tooltip title="Delete" arrow>
                          <DeleteIcon onClick={() => removequickLinks(index)} style={{ color: "red", cursor: "pointer" }} />
                        </Tooltip>
                      }
                    </div>
                  </div>
                ))}
                <div className="form-row  mb-2">
                  <Grid className="d-flex justify-content-between">
                    <Tooltip title="Add" arrow>
                      <Button
                        className="button "
                        variant="outlined"
                        disableElevation
                        startIcon={<Add />}
                        onClick={() =>
                          appendquickLinks({
                            link: "",
                            target: "",
                            order: "",
                            text: "",
                          })
                        }
                      >
                        Add
                      </Button>
                    </Tooltip>
                  </Grid>
                </div>
              </div>
              <hr />
            </Col>
            <Col lg={6}>
              <div className="text-success buttons rounded-2 fw-bold mb-3 mt-3" style={{ cursor: "pointer" }} onClick={() => toggleColumn('bank_partners')}>
                Create Bank Partners  {columnVisibility.bank_partners ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
              </div>
              <div style={{ display: columnVisibility.bank_partners ? 'block' : 'none' }}>
                {bankPartners.map((item, index) => (
                  <div key={item.id} className="form-row ">
                    <div className="column">
                      <Controller
                        name={`bank_partners[${index}].text`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Text"
                            className={`form-control mb-2 ${errors.bank_partners &&
                              errors?.bank_partners[index]?.text
                              ? "error"
                              : ""
                              }`}
                          />
                        )}
                      />
                    </div>

                    <div className="column">
                      <Controller
                        name={`bank_partners[${index}].link`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Link"
                            className={`form-control mb-2 ${errors.bank_partners &&
                              errors?.bank_partners[index]?.link
                              ? "error"
                              : ""
                              }`}
                          />
                        )}
                      />
                    </div>
                    <div className="column d-flex gap-3">
                      <Controller
                        name={`bank_partners[${index}].target`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Target"
                            select
                            className={`form-control mb-2 ${errors.bank_partners &&
                              errors?.bank_partners[index]?.target
                              ? "error"
                              : ""
                              }`}
                          >
                            <MenuItem value="_self">_self</MenuItem>
                            <MenuItem value="_blank">_blank</MenuItem>
                          </TextField>
                        )}
                      />
                      <Controller
                        name={`bank_partners[${index}].order`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Order"
                            select
                            className={`form-control mb-2 ${errors.bank_partners &&
                              errors?.bank_partners[index]?.order
                              ? "error"
                              : ""
                              }`}
                          >
                            {[...Array(15).keys()].map((number) => (
                              <MenuItem
                                key={number + 1}
                                value={(number + 1).toString()}
                              >
                                {number + 1}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                      />
                    </div>
                    <div className="column d-flex justify-content-end">
                      {bankPartners.length > 0 &&
                        <Tooltip title="Delete" arrow>
                          <DeleteIcon onClick={() => removebankPartners(index)} style={{ color: "red", cursor: "pointer" }} />
                        </Tooltip>
                      }
                    </div>
                  </div>
                ))}
                <div className="form-row  mb-2">
                  <Grid className="d-flex justify-content-between">
                    <Tooltip title="Add" arrow>
                      <Button
                        className="button "
                        variant="outlined"
                        disableElevation
                        startIcon={<Add />}
                        onClick={() =>
                          appendbankPartners({
                            link: "",
                            target: "",
                            order: "",
                            text: "",
                          })
                        }
                      >
                        Add
                      </Button>
                    </Tooltip>
                  </Grid>
                </div>
              </div>
              <hr />
            </Col>
          </Row>

          <Row>
            <Col lg={6} className="mt-3">
              <div className="column ">
                <Controller
                  name="copy_right"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="text"
                      className={`form-control mb-2 ${errors.copy_right ? "error" : ""}`}
                      label="Enter Copy Right*"
                      error={!!errors.copy_right}
                      helperText={errors.copy_right ? errors.copy_right.message : ''}
                    />
                  )}
                />
              </div>
              <hr />
            </Col>
            <Col lg={6}>
              <div className={`text-success fw-bold text-center buttons rounded-2 ${errors.footer_images && "error"}`} style={{ cursor: "pointer" }} onClick={() => toggleColumn('footer_images')}>
                Footer Image <StarRateIcon className={`${errors.footer_images && "text-danger"}`} /> {columnVisibility.footer_images ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
              </div>
              <div style={{ display: columnVisibility.footer_images ? 'block' : 'none' }}>
                <InputFieldOrder
                  fieldName={`footer_images`}
                  appendfunc={appendPhoto}
                  remove={removePhoto}
                  fieldsArray={photoFields}
                  watch={watch}
                  register={register}
                  handleImageFunc={handleImage}
                  clearErrorsfunc={clearErrors}
                  handleUrlChangefunc={handleUrlChange}
                  control={control}
                  errors={errors}
                />
                <hr />
              </div>
              <hr />
            </Col>
          </Row>
          <Grid className="d-flex justify-content-end">
            <Toolbar className="p-0">
              <Button
                className="button "
                variant="contained"
                disableElevation
                endIcon={<NavigateNextIcon />}
                type="submit"
              >
                Finish
              </Button>
            </Toolbar>
          </Grid>
        </div>
      </form>
    </div>
  );
};

export default FooterCreation;
